// src/components/HandbookLink.js - RULING 302 (D7, ruling 278 item 7).
// Bob, 2026-10-08: the handbooks are published inside the platform, each role its own. A link in the sidebar footer,
// not a screen (ruling 170's screen list and the handbooks' screen tables are unchanged). The file is fetched with a
// short-lived download address from private Storage; storage.rules decides whether this account may read it.
import React, { useState } from 'react';
import { ref, getDownloadURL } from 'firebase/storage';
import { storage } from '../firebase';
import { handbooksFor } from '../data/handbooks';

export default function HandbookLink({ user }) {
  const [busy, setBusy] = useState('');
  const [err, setErr] = useState('');
  const list = handbooksFor(user);
  if (!list.length) return null;
  const open = async (h) => {
    setBusy(h.path); setErr('');
    try {
      const url = await getDownloadURL(ref(storage, h.path));
      window.open(url, '_blank', 'noopener,noreferrer');
    } catch (e) {
      setErr('The handbook could not be opened (' + ((e && e.code) || 'unavailable') + ').');
    } finally { setBusy(''); }
  };
  return (
    <div style={{ marginTop: 10 }}>
      {list.map((h) => (
        <div key={h.path}>
          <span role="button" tabIndex={0} style={{ fontSize: 11, color: '#E8A020', cursor: 'pointer' }}
            onClick={() => !busy && open(h)} onKeyDown={(e) => { if (e.key === 'Enter' && !busy) open(h); }}>
            {busy === h.path ? 'Opening…' : h.label + ' (PDF)'}
          </span>
        </div>
      ))}
      {err ? <div style={{ fontSize: 11, color: '#E06C6C', marginTop: 4 }}>{err}</div> : null}
    </div>
  );
}
